import { render } from "./media-control-pause.svg?vue&type=template&id=29a0b03d"
const script = {}
script.render = render

export default script